'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isEmpty2 = require('lodash/isEmpty');

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _omit2 = require('lodash/omit');

var _omit3 = _interopRequireDefault(_omit2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _createConnector = require('../core/createConnector');

var _createConnector2 = _interopRequireDefault(_createConnector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var namespace = 'refinementList';

function getId(props) {
  return props.attributeName;
}

function getCurrentRefinement(props, searchState) {
  var id = getId(props);
  if (searchState[namespace] && typeof searchState[namespace][id] !== 'undefined') {
    var subState = searchState[namespace];
    if (typeof subState[id] === 'string') {
      // All items were unselected
      if (subState[id] === '') {
        return [];
      }

      // Only one item was in the searchState but we know it should be an array
      return [subState[id]];
    }
    return subState[id];
  }
  if (props.defaultRefinement) {
    return props.defaultRefinement;
  }
  return [];
}

function getValue(name, props, searchState) {
  var currentRefinement = getCurrentRefinement(props, searchState);
  var isAnewValue = currentRefinement.indexOf(name) === -1;
  var nextRefinement = isAnewValue ? currentRefinement.concat([name]) : // cannot use .push(), it mutates
  currentRefinement.filter(function (selectedValue) {
    return selectedValue !== name;
  }); // cannot use .splice(), it mutates
  return nextRefinement;
}

/**
 * connectRefinementList connector provides the logic to build a widget that will
 * give the user tha ability to choose multiple values for a specific facet.
 * @name connectRefinementList
 * @kind connector
 * @propType {string} [operator=or] - How to apply the refinements. Possible values: 'or' or 'and'.
 * @propType {string} attributeName - the name of the attribute in the record
 * @propType {boolean} [showMore=false] - true if the component should display a button that will expand the number of items
 * @propType {number} [limitMin=10] - the minimum number of displayed items
 * @propType {number} [limitMax=20] - the maximun number of displayed items. Only used when showMore is set to `true`
 * @propType {string[]} defaultRefinement - the values of the items selected by default. The searchState of this widget takes the form of a list of `string`s, which correspond to the values of all selected refinements. However, when there are no refinements selected, the value of the searchState is an empty string.
 * @propType {boolean} [searchForFacetValues=false] - if set to true, the searchForFacetValues function is provided
 * @propType {function} [transformItems] - If provided, this function can be used to modify the `items` provided prop of the wrapped component (ex: for filtering or sorting items). this function takes the `items` prop as a parameter and expects it back in return.
 * @providedPropType {function} refine - a function to toggle a refinement
 * @providedPropType {function} createURL - a function to generate a URL for the corresponding search state
 * @providedPropType {function} searchForFacetValues - a function to toggle a search for facet values
 * @providedPropType {string[]} currentRefinement - the refinement currently applied
 * @providedPropType {array.<{count: number, isRefined: boolean, label: string, value: string}>} items - the list of items the RefinementList can display.
 * @providedPropType {boolean} isFromSearch - a boolean that says if the `items` props contains facet values from the global search or from the search for facet values results.
 */

var sortBy = ['isRefined', 'count:desc', 'name:asc'];

var _default = (0, _createConnector2.default)({
  displayName: 'AlgoliaRefinementList',

  propTypes: {
    id: _react.PropTypes.string,
    attributeName: _react.PropTypes.string.isRequired,
    operator: _react.PropTypes.oneOf(['and', 'or']),
    showMore: _react.PropTypes.bool,
    limitMin: _react.PropTypes.number,
    limitMax: _react.PropTypes.number,
    defaultRefinement: _react.PropTypes.arrayOf(_react.PropTypes.string),
    searchForFacetValues: _react.PropTypes.bool,
    transformItems: _react.PropTypes.func
  },

  defaultProps: {
    operator: 'or',
    showMore: false,
    limitMin: 10,
    limitMax: 20
  },

  getProvidedProps: function getProvidedProps(props, searchState, searchResults, metadata, searchForFacetValuesResults) {
    var results = searchResults.results;
    var attributeName = props.attributeName,
        showMore = props.showMore,
        limitMin = props.limitMin,
        limitMax = props.limitMax;

    var limit = showMore ? limitMax : limitMin;

    var isFacetPresent = Boolean(results) && Boolean(results.getFacetByName(attributeName));

    if (!isFacetPresent) {
      return null;
    }

    var isFromSearch = Boolean(searchForFacetValuesResults && searchForFacetValuesResults[attributeName] && searchForFacetValuesResults.query !== '');

    var items = isFromSearch ? searchForFacetValuesResults[attributeName].map(function (v) {
      return {
        label: v.value,
        value: getValue(v.value, props, searchState),
        _highlightResult: { label: { value: v.highlighted } },
        count: v.count,
        isRefined: v.isRefined
      };
    }) : results.getFacetValues(attributeName, { sortBy: sortBy }).map(function (v) {
      return {
        label: v.name,
        value: getValue(v.name, props, searchState),
        count: v.count,
        isRefined: v.isRefined
      };
    });

    var transformedItems = props.transformItems ? props.transformItems(items) : items;
    var searchForFacetValues = props.searchForFacetValues ? this.searchForFacetValues : undefined;

    return {
      items: transformedItems.slice(0, limit),
      currentRefinement: getCurrentRefinement(props, searchState),
      isFromSearch: isFromSearch,
      searchForFacetValues: searchForFacetValues
    };
  },
  refine: function refine(props, searchState, nextRefinement) {
    var id = getId(props);
    return _extends({}, searchState, _defineProperty({}, namespace, _extends({}, searchState[namespace], _defineProperty({}, id, nextRefinement.length > 0 ? nextRefinement : ''))));
  },
  searchForFacetValues: function searchForFacetValues(props, searchState, nextRefinement) {
    return { facetName: props.attributeName, query: nextRefinement };
  },
  cleanUp: function cleanUp(props, searchState) {
    var cleanState = (0, _omit3.default)(searchState, namespace + '.' + getId(props));
    if ((0, _isEmpty3.default)(cleanState[namespace])) {
      return (0, _omit3.default)(cleanState, namespace);
    }
    return cleanState;
  },
  getSearchParameters: function getSearchParameters(searchParameters, props, searchState) {
    var attributeName = props.attributeName,
        operator = props.operator,
        showMore = props.showMore,
        limitMin = props.limitMin,
        limitMax = props.limitMax;

    var limit = showMore ? limitMax : limitMin;

    var addKey = operator === 'and' ? 'addFacet' : 'addDisjunctiveFacet';
    var addRefinementKey = addKey + 'Refinement';

    searchParameters = searchParameters.setQueryParameters({
      maxValuesPerFacet: Math.max(searchParameters.maxValuesPerFacet || 0, limit)
    });

    searchParameters = searchParameters[addKey](attributeName);

    return getCurrentRefinement(props, searchState).reduce(function (res, val) {
      return res[addRefinementKey](attributeName, val);
    }, searchParameters);
  },
  getMetadata: function getMetadata(props, searchState) {
    var id = getId(props);
    return {
      id: id,
      items: getCurrentRefinement(props, searchState).length > 0 ? [{
        attributeName: props.attributeName,
        label: props.attributeName + ': ',
        currentRefinement: getCurrentRefinement(props, searchState),
        value: function value(nextState) {
          return _extends({}, nextState, _defineProperty({}, namespace, _extends({}, nextState[namespace], _defineProperty({}, id, ''))));
        },
        items: getCurrentRefinement(props, searchState).map(function (item) {
          return {
            label: '' + item,
            value: function value(nextState) {
              var nextSelectedItems = getCurrentRefinement(props, nextState).filter(function (other) {
                return other !== item;
              });

              return _extends({}, nextState, _defineProperty({}, namespace, _extends({}, nextState[namespace], _defineProperty({}, id, nextSelectedItems.length > 0 ? nextSelectedItems : ''))));
            }
          };
        })
      }] : []
    };
  }
});

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(namespace, 'namespace', 'src/connectors/connectRefinementList.js');

  __REACT_HOT_LOADER__.register(getId, 'getId', 'src/connectors/connectRefinementList.js');

  __REACT_HOT_LOADER__.register(getCurrentRefinement, 'getCurrentRefinement', 'src/connectors/connectRefinementList.js');

  __REACT_HOT_LOADER__.register(getValue, 'getValue', 'src/connectors/connectRefinementList.js');

  __REACT_HOT_LOADER__.register(sortBy, 'sortBy', 'src/connectors/connectRefinementList.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/connectors/connectRefinementList.js');
}();

;


//////////////////
// WEBPACK FOOTER
// /tmp/~/react-instantsearch/src/connectors/connectRefinementList.js
// module id = 522
// module chunks = 0